import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { App } from './App'

import { Provider } from 'react-redux'
import { store } from './app-state/redux-store'
import { CookiesProvider } from 'react-cookie'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Maintenance } from '@Components/maintenance/maintenance'

const router = createBrowserRouter([
  {
    path: '/keno-to-go',
    element: <App />,
    children: [
      {
        path: 'maintenance',
        element: <Maintenance />,
      },
    ],
  },
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </CookiesProvider>
  </React.StrictMode>,
)
